import { render } from "./request-processes-modal.vue?vue&type=template&id=396cc528&ts=true"
import script from "./request-processes-modal.vue?vue&type=script&lang=ts"
export * from "./request-processes-modal.vue?vue&type=script&lang=ts"

import "./request-processes-modal.vue?vue&type=style&index=0&id=396cc528&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__